import React from 'react'
import { useSelector } from 'react-redux'

import { getHasOpenDialogs } from '~/store/duck/dialogs'

import AgentButton from './AgentButton'
import { useAgentChat } from './AgentChatContext'

/**
 * Floating button component that displays the AI Assistant chat button when modals are open
 * and the chat is closed. This provides users access to the assistant even when modal overlays
 * are active, ensuring the assistant remains accessible during modal interactions.
 *
 * The button automatically hides when:
 * - No dialogs/modals are open
 * - The chat is already open
 */
const AgentFloatingButton = () => {
  const { isChatOpen } = useAgentChat()
  const hasOpenDialogs = useSelector(getHasOpenDialogs)

  // Only show when modals are open and chat is closed
  if (!hasOpenDialogs || isChatOpen) {
    return null
  }

  return <AgentButton isFloating />
}

export default AgentFloatingButton
